import React from 'react';
import { Grid } from '@mui/material';
import { FormFieldContext, FormFieldContextValue } from './FormFieldContext';
import { FormFieldLabel } from './FormFieldLabel';
import { FormFieldError } from './FormFieldError';
import { FormFieldMessage } from './FormFieldMessage';

interface FormFieldProps extends FormFieldContextValue {
  children: React.ReactNode;
  showLabel?: boolean;
  themeOptions?: {
    errorMessageMarginTop?: number;
  };
}

export const FormField: React.FC<FormFieldProps> = ({
  children,
  showLabel = true,
  themeOptions = {},
  ...contextValue
}) => {
  const { fieldMeta, field } = contextValue;

  return (
    <FormFieldContext.Provider value={contextValue}>
      <Grid
        id={fieldMeta?.Key}
        key={`${fieldMeta?.Key}-${fieldMeta?.Type}`}
        size={{
          xs: 12,
          sm: field.Layout === 'fluid-single' ? 6 : 12,
        }}
        sx={{
          '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
              borderColor: (theme) =>
                `${theme.palette.error.medium} !important`,
            },
        }}
      >
        {showLabel && <FormFieldLabel />}
        {children}
        <FormFieldError marginTop={themeOptions.errorMessageMarginTop} />
        <FormFieldMessage />
      </Grid>
    </FormFieldContext.Provider>
  );
};
